const supplierCatalog = [
    {
        selector: '[data-react="supplierCatalog"]',
        path: { filename: 'App' },
    },
];

export { supplierCatalog };
